<template>
  <!-- 供应商指令-->
  <div class="supplierDeliveryOrder">
    <!-- 搜索区域 -->
    <SiruiSearch
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      :defaultRow="2"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="searchBtnClick"
      @searchCompanyName="searchCompanyName"
      @changeProject="changeProject"
      @changePerson="changePerson"
    ></SiruiSearch>

    <!--内容区域-->
    <div class="main-content">
      <!-- <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :showFooter="1 == 1"
        :footerMethod="footerTotalCols ? footerMethodTotal : null"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      > -->
      <sirui-table
        ref="siruiTable"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :reserve="true"
        :setting="false"
        :customVisible="true"
        :columns="columnList"
        :rowStyle="rowStyle"
        @chooseClick="chooseClick"
        @dblclickEvent="dblclickEvent"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
        @sortChangeEvent="sortChangeEvent"
      >
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :visible="item.visible"
          :fixed="item.fixed"
          :width="item.width"
          :precision="item.precision"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
        >
          <template slot-scope="scope">
            <!-- 发货方式 -->
            <!-- <span v-if="item.field === 'deliverMethod'">{{
              transferSelectLabel(scope.row[item.field], deliverMethodOptions)
            }}</span> -->
            <span v-if="item.field === 'directDeliver'">{{
              transferSelectLabel(scope.row[item.field], directDeliverOptions)
            }}</span>
            <span v-else-if="item.field === 'instructionStatus'">{{
              transferSelectLabel(scope.row[item.field], instructionStatusOptions)
            }}</span>
            <span v-else-if="item.field === 'businessMode'">{{
              transferSelectLabel(scope.row[item.field], businessModeList)
            }}</span>
            <span v-else-if="item.field === 'distributionMode'">{{
              transferSelectLabel(scope.row[item.field], deliveryOptions)
            }}</span>
            <span v-else-if="item.field === 'isRelatedOtherInstruction'">
              {{ transferSelectLabel(scope.row[item.field], eList) }}
            </span>
            <span v-else-if="item.field === 'unit'">{{
              transferSelectLabel(scope.row[item.field], unitOptions)
            }}</span>
            <span v-else-if="item.field === 'lockStatus'">{{
              transferSelectLabel(scope.row[item.field], lockStatusList)
            }}</span>
            <span v-else-if="item.field === 'payStatus'">{{
              transferSelectLabel(scope.row[item.field], payStatusList)
            }}</span>
            <span v-else-if="['contractNo'].includes(item.field)">{{
              replaceLastZeroStr(scope.row[item.field])
            }}</span>
            <span v-else>{{ scope.row[item.field] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <!-- <quotingPurchase ref="quotingPurchase"></quotingPurchase> -->
    <creat-dialog ref="creatDialog"></creat-dialog>
    <paymentDialog
      v-if="paymentDialogVisible"
      :dialogVisible="paymentDialogVisible"
      :paymentList="paymentList"
      @close="handlePaymentClose"
    />
    <recordDialog
      v-if="recordDialogVisible"
      :dialogVisible="recordDialogVisible"
      :recordInstructionNo="recordInstructionNo"
      :businessInboundBatchNo="businessInboundBatchNo"
      @close="handleRecordClose"
    />
    <!-- 生成业务入库单 -->
    <businessReceiptDialog ref="businessReceiptDialog"></businessReceiptDialog>
    <!-- sunxueping 添加批量导入 -->
    <sirui-upload
      :action="action"
      @getData="getData"
      ref="SiruiUpload"
      :data="{ ...token }"
      :isShowDownTemplateBtn="true"
    ></sirui-upload>
    <!-- ====================== -->
    <!-- 打印弹框 -->
    <PrintDialog ref="printDialogRef" :apiUrl="printApi" />
  </div>
</template>
<script>
  // import axios from 'axios';
  import { mapState } from 'vuex';
  import API from '@/api/wareHouse/supplierDeliveryOrder.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import BASEAPI from '@/api/dataBase.js';
  import SiruiTable from '@/components/SiruiTable';
  import creatDialog from './components/creatDialog';
  import paymentDialog from './components/paymentDialog';
  import recordDialog from './components/recordDialog';
  // import recordDialog from './components/recordDialog';
  import businessReceiptDialog from './components/businessReceiptDialog'; //物流入库单弹框
  //import quotingPurchase from "./supplierDeliveryOrderModel/quotingPurchase";
  // ============ sunxueping 添加批量导入 ============
  import siruiUpload from '@/components/SiruiUpload';
  import { filterEmpty, getUserCompanyList } from '@/common/js/util';
  import tableMixins from '@/common/mixins/table.js';
  // ================================================
  import XEUtils from 'xe-utils';
  export default {
    components: {
      SiruiTable,
      SiruiSearch,
      //quotingPurchase,
      creatDialog,
      paymentDialog,
      recordDialog,
      businessReceiptDialog, //物流入库单弹框
      //  sunxueping 添加批量导入
      siruiUpload,
      // =======================
    },
    name: 'supplierDeliveryOrder',
    mixins: [tableMixins],
    data() {
      return {
        //底部合计列-字段名，数字类型金额amount，数量quantity等）判断小数点
        footerTotalCols: {
          amount: [],
          //供应商发货指令数量 //物流已入库数量 //已业务入库数量
          quantity: ['instructionNumber', 'inboundQuantity', 'businessInboundQuantity'],
        },
        //  sunxueping 添加批量导入
        action: API.IMPORT_SHIPPINGINSTRUCTION,
        // =======================
        load: false,
        isMultiple: true,
        img: '/static/img/tips.png',
        printApi: API.PRINT_API,
        instructionStatusOptions: [], //发货指令状态下拉
        // deliverMethodOptions: [], //发货方式下拉
        directDeliverOptions: [], //是否直拨下拉
        query: {
          instructionNo: null, //发货指令编号
          // deliverMethod: null, //发货方式
          // directDeliver: null, //是否直拨
          projectName: null, //项目简称
          settleBatchNo: null, //结算批次号
          partnerNo: null, //供应商
          purchaseContractNo: null, //采购合同号
          instructionStatus: null, //发货指令状态
          instructionCreateStartDate: null, //创建日期起
          instructionCreateEndDate: null, //创建日期止
          expectArrivalStartDate: null, //预计到货日期起
          expectArrivalEndDate: null, //预计到货日期止
          deliverStartDate: null, //发货日期起
          deliverEndDate: null, //发货日期止
          instructionCompanyNo: null, //公司
          instructionCompanyName: null, //公司
          instructionDepartmentNo: null, //部门
          salesmanNo: null, //业务员
          instructionCreatePersonNo: null, //制单人
          // storageNo: null, //仓库
          // distributionMode: null, //运输方式
          productNo: null, //商品
          // purchaseIntentNo: null, //意向单号
          externalContractNo: null, //外部合同号
          businessInboundBatchNo: null, // 入库批次号
          // distributionBatchNo: null,
          isRelatedOtherInstruction: null, // 是否有关联供应商发货指令
          relatedInstructionNo: null, // 关联供应商指令号
          lockStatus: '',
          payStatus: '',
          personIds: [],
          personNames: '',
        },
        multipleSelection: [], //存放选中的值
        menuButtonList: [],
        tableData: [],
        companyList: getUserCompanyList(),
        departmentList: [], //部门列表
        columnList: [],
        //表格显示字段
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          { field: 'settleBatchNo', title: '结算批次号', visible: true },
          // 采购合同号
          {
            field: 'purchaseContractNo',
            title: 'supplierDeliveryOrder.search.purchaseContractNo',
            visible: true,
          },
          { field: 'projectName', title: '项目简称', visible: true },
          // 公司
          {
            field: 'instructionCompanyName',
            title: 'supplierDeliveryOrder.search.companyName',
            visible: true,
          },
          { field: 'inboundDate', title: '业务入库日期', visible: true }, // 后端字段未给
          {
            field: 'shipingMethod',

            title: '运输方式',

            visible: true,
          },
          { field: 'carNo', title: '车牌号', visible: true },
          { field: 'productDesc', title: 'supplierDeliveryOrder.table.productDesc', visible: true },
          {
            field: 'roughWeight',

            title: '毛重',

            visible: true,
          },
          {
            field: 'tare',

            title: '皮重',

            visible: true,
          },
          { field: 'netWeight', title: '净重', visible: true },
          { field: 'deduct', title: '扣杂', visible: true },
          {
            field: 'netReceipt',

            title: '实收',

            visible: true,
          },
          { field: 'businessVariablePrice', title: '业务结算价', visible: true },
          { field: 'businessVariablePriceWithTax', title: '业务结算价含税金额', visible: true }, // 后端字段未给
          { field: 'partnerName', title: 'supplierDeliveryOrder.table.partnerName', visible: true },
          {
            field: 'instructionNo',
            title: 'supplierDeliveryOrder.search.instructionNolist',
            fixed: 'left',
            width: 120,
            visible: true,
          },

          {
            field: 'spec',

            title: '规格',

            visible: true,
          },

          // prd 无意向单号
          // {
          //   field: 'purchaseIntentNo',
          //   title: 'supplierDeliveryOrder.search.purchaseIntentNo',
          //   visible: true,
          // },
          {
            field: 'externalContractNo',
            title: 'supplierDeliveryOrder.search.externalContractNo',
            visible: true,
          },
          // {
          //   field: 'deliverMethod',
          //   title: 'supplierDeliveryOrder.search.deliverMethod',
          //   visible: true,
          // },
          // {
          //   field: 'directDeliver',
          //   title: 'supplierDeliveryOrder.search.directDeliver',
          //   visible: true,
          // },
          {
            field: 'instructionStatus',
            title: 'supplierDeliveryOrder.search.instructionStatus',
            visible: true,
          },
          // {
          //   field: 'deliverToStorageName',
          //   title: 'supplierDeliveryOrder.search.storageName',
          //   visible: true,
          // },
          {
            field: 'instructionDepartmentName',
            title: 'supplierDeliveryOrder.search.departmentName',
            visible: true,
          },

          {
            field: 'deliverFromAddress',
            title: 'supplierDeliveryOrder.table.deliverFromAddress',
            visible: true,
          },
          // {
          //   field: 'distributionMode',
          //   title: 'supplierDeliveryOrder.search.distributionMode',
          //   visible: true,
          // },
          {
            field: 'instructionCreateDate',
            title: 'supplierDeliveryOrder.table.instructionCreateDate',
            visible: true,
          },
          {
            field: 'salesmanName',
            title: 'supplierDeliveryOrder.search.salesmanName',
            visible: true,
          },
          {
            field: 'businessMode',
            title: '业务性质',
            visible: true,
          },
          {
            field: 'instructionCreatePersonName',
            title: 'supplierDeliveryOrder.search.createPersonName',
            visible: true,
          },
          { field: 'unit', title: 'supplierDeliveryOrder.table.unit', visible: true },
          {
            field: 'instructionNumber',
            title: 'supplierDeliveryOrder.table.instructionNumber',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          {
            field: 'contractNo',
            title: '采购合同数量',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          {
            field: 'inboundQuantity',
            title: '物流入库数量',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          {
            field: 'businessInboundQuantity',
            title: '已业务入库数量',
            visible: true,
            precision: this.$globalVar.qPoint,
          },
          { field: 'deliverDate', title: 'supplierDeliveryOrder.table.deliverDate', visible: true },
          {
            field: 'expectArrivalDate',
            title: 'supplierDeliveryOrder.table.expectArrivalDate',
            visible: true,
          },
          // { field: 'distributionBatchNo', title: '物流批次号', visible: true },
          { field: 'shippingMark', title: 'supplierDeliveryOrder.table.mark', visible: true },

          { field: 'wayBillNo', title: '运单号', visible: true },
          { field: 'businessInboundNo', title: '业务入库单号', visible: true },
          // { field: 'contractType', title: '合同类型', visible: true }, // 后端字段未给
          { field: 'businessInboundBatchNo', title: '入库批次号', visible: true },

          { field: 'businessContractPrice', title: '合同价', visible: true }, // 后端字段未给

          { field: 'businessContractPriceWithTax', title: '合同价含税金额', visible: true }, // 后端字段未给
          { field: 'businessContractPricePureAmount', title: '合同净值价', visible: true }, // 后端字段未给
          { field: 'businessContractPriceTaxAmount', title: '合同价税额', visible: true }, // 后端字段未给
          { field: 'matchedQuantity', title: '已匹配数量', visible: true }, // 后端字段未给
          { field: 'matchAvailableQuantity', title: '可匹配数量', visible: true }, // 后端字段未给
          { field: 'taxRate', title: '税率', visible: true }, // 后端字段未给

          { field: 'isRelatedOtherInstruction', title: '是否关联供应商发货指令', visible: true }, // 后端字段未给
          { field: 'relatedInstructionNo', title: '关联供应商发货指令号', visible: true }, // 后端字段未给
          { field: 'platformCompanyName', title: '平台公司名称', visible: true },
          { field: 'baseName', title: '基地简称', visible: true },

          { field: 'lockStatus', title: '锁定状态', visible: true },
          { field: 'payStatus', title: '付款状态', visible: true },
          { field: 'paidMoney', title: '已付款金额', visible: true },
          { field: 'unPaidMoney', title: '未付款金额', visible: true },
        ],
        lockStatusList: [
          { label: '未锁定', value: 0 },
          { label: '已锁定', value: 1 },
        ],
        payStatusList: [
          { label: '未付款', value: 0 },
          { label: '部分付款', value: 1 },
          { label: '已付款', value: 2 },
        ],
        paymentDialogVisible: false,
        paymentList: [],
        recordDialogVisible: false,
        recordInstructionNo: '',
        businessInboundBatchNo: '',
      };
    },
    created() {
      // 发货方式
      // this.deliverMethodOptions = [
      //   { value: '0', label: this.$t('supplierDeliveryOrder.search.deliverMethodOptionOne') },
      //   { value: '1', label: this.$t('supplierDeliveryOrder.search.deliverMethodOptionTwo') },
      //   { value: '2', label: this.$t('supplierDeliveryOrder.search.deliverMethodOptionThree') },
      //   { value: '3', label: this.$t('supplierDeliveryOrder.search.deliverMethodOptionFour') },
      // ];
      //是否直拨
      this.directDeliverOptions = [
        { value: '1', label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionOne') },
        { value: '0', label: this.$t('supplierDeliveryOrder.search.isDirectDeliverOptionTwo') },
      ];
      //状态下拉
      this.instructionStatusOptions = [
        { value: '0', label: this.$t('supplierDeliveryOrder.search.instructionStatusOptionOne') },
        // { value: '1', label: this.$t('supplierDeliveryOrder.search.instructionStatusOptionTwo') },
        { value: '1', label: this.$t('supplierDeliveryOrder.search.instructionStatusOptionThree') },
        { value: '3', label: '已撤销' },
      ];
      // 是否有关联供应商发货指令
      this.eList = [
        { value: 'Y', label: '是' },
        { value: 'N', label: '否' },
      ];
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
        //运输方式下拉
        deliveryOptions(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'delivery_method').dictList;
          }
        },
        //单位下拉1
        unitOptions(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'basic_unit').dictList;
          }
        },
        // 业务性质下拉
        businessModeList(state) {
          if (state.dict.dictList.length > 10) {
            return state.dict.dictList.find((it) => it.dictType == 'purchase_business_type')
              .dictList;
          }
        },
      }),
      // sunxueping 添加
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
          businessGroup: this.userInfo.businessGroup,
        };
      },
      // ==============
      //搜索字段
      searchColumns() {
        return [
          {
            prop: 'personNames',
            name: '制单人',
            searchType: 'personnel',
            type: 'searchTableSpec',
            isMultiple: false,
            currentValue: this.query?.personNames ? this.query?.personNames : null,
            checkRowKeys: this.query.personIds,
            extraData: {
              personDepartmentCode: this.userInfo.departmentCode,
            },
            changeMethod: 'changePerson',
          },

          {
            prop: 'instructionNo',
            // name: this.$t('supplierDeliveryOrder.search.instructionNo'),
            name: '供应商发货指令编号',
            type: 'input',
            placeholder: this.$t('supplierDeliveryOrder.search.instructionNoPlaceholder'),
          },
          // {
          //   prop: 'deliverMethod',
          //   name: this.$t('supplierDeliveryOrder.search.deliverMethod'),
          //   type: 'select',
          //   placeholder: this.$t('supplierDeliveryOrder.search.deliverMethodPlaceholder'),
          //   options: this.deliverMethodOptions,
          // },
          // 是否直拨 prd上无
          // {
          //   prop: 'directDeliver',
          //   name: this.$t('supplierDeliveryOrder.search.directDeliver'),
          //   type: 'select',
          //   placeholder: this.$t('supplierDeliveryOrder.search.isDirectDeliverPlaceholder'),
          //   options: this.directDeliverOptions,
          // },
          //供应商  下拉选择
          {
            type: 'searchTableSpec',
            name: this.$t('contractAgency.supplier'),
            prop: 'partnerNo',
            searchType: 'supplier',
            propCode: 'partnerCode',
            propName: 'partnerZhName',
            extraData: {
              departmentCode: this.query.instructionDepartmentNo, //部门
              companyCode: this.query.instructionCompanyNo, //公司
            },
            isMultiple: true,
          },
          {
            prop: 'instructionCompanyNo',
            name: this.$t('supplierDeliveryOrder.search.companyName'),
            type: 'select',
            placeholder: this.$t('payablesBillList.search.companyCodePlaceholder'),
            options: this.companyList,
            relatedColumn: 'none',
            clearable: false,
            changeMethod: 'searchCompanyName',
          },
          //部门
          {
            prop: 'instructionDepartmentNo',
            name: this.$t('supplierDeliveryOrder.search.departmentName'),
            type: 'select',
            options: this.departmentList,
          },
          {
            prop: 'purchaseContractNo',
            name: this.$t('supplierDeliveryOrder.search.purchaseContractNo'),
            type: 'input',
            placeholder: this.$t('supplierDeliveryOrder.search.purchaseContractNoPlaceholder'),
          },
          {
            prop: 'projectName',
            name: '项目简称',
            searchType: 'projectInitiation',
            type: 'searchTableSpec',
            isMultiple: true,
            currentValue: this.query?.projectName ? this.query?.projectName : null,
            checkRowKeys: [this.query.projectInitiationNo ? this.query.projectInitiationNo : null],
            extraData: {
              projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
              // applyCompanyNo: this.query.instructionCompanyNo,
              // applyDepartmentNo: this.query.instructionDepartmentNo,
              // platformtCompany: this.query.instructionCompanyNo,
              // recyclingtCompany: this.query.instructionCompanyNo,

              // applyCompanyName: this.userInfo.companyName,
              // platformtCompanyName: this.userInfo.companyName,
              // recyclingtCompanyName: this.userInfo.companyName,
            },
            changeMethod: 'changeProject',
          },
          {
            prop: 'settleBatchNo',
            name: '结算批次号',
            type: 'input',
            placeholder: '请输入',
          },
          {
            prop: 'instructionStatus',
            name: this.$t('supplierDeliveryOrder.search.instructionStatus'),
            type: 'select',
            placeholder: this.$t('supplierDeliveryOrder.search.instructionStatusPlaceholder'),
            options: this.instructionStatusOptions,
          },
          // {
          //   prop: 'projectName',
          //   name: '项目简称',
          //   type: 'input',
          //   placeholder: '请输入',
          // },

          // {
          //   prop: 'instructionCreateStartDate',
          //   name: this.$t('supplierDeliveryOrder.search.instructionCreateStartDate'),
          //   type: 'startDaterangePicker',
          // },
          // {
          //   prop: 'instructionCreateEndDate',
          //   name: this.$t('supplierDeliveryOrder.search.instructionCreateEndDate'),
          //   type: 'endDaterangePicker',
          // },
          // {
          //   prop: 'expectArrivalStartDate',
          //   name: this.$t('supplierDeliveryOrder.search.expectArrivalStartDate'),
          //   type: 'startDaterangePicker',
          // },
          // {
          //   prop: 'expectArrivalEndDate',
          //   name: this.$t('supplierDeliveryOrder.search.expectArrivalEndDate'),
          //   type: 'endDaterangePicker',
          // },
          // {
          //   prop: 'deliverStartDate',
          //   name: this.$t('supplierDeliveryOrder.search.deliverStartDate'),
          //   type: 'startDaterangePicker',
          // },
          // {
          //   prop: 'deliverEndDate',
          //   name: this.$t('supplierDeliveryOrder.search.deliverEndDate'),
          //   type: 'endDaterangePicker',
          // },
          //制单人
          // {
          //   type: 'searchTableSpec',
          //   prop: 'instructionCreatePersonNo',
          //   name: this.$t('supplierDeliveryOrder.search.createPersonName'),
          //   isMultiple: true,
          //   searchType: 'personnel',
          // },

          //商品
          {
            type: 'searchTableSpec',
            prop: 'productNo',
            name: this.$t('supplierDeliveryOrder.search.goodDesc'),
            isMultiple: true,
            searchType: 'usableProduct',
            extraData: {
              detailProductStatus: 'ZT03',
              contractCategory: 'purchase',
              adminFlag: 2,
              selectCompanyCode: '',
            },
          },
          //     name: '合同标的',
          // prop: 'contractMatter',
          // type: 'searchTableSpec',
          // searchType: 'usableProduct',
          // isNeedMultipleValue: true,
          // isMultiple: true,
          // extraData: {
          //   detailProductStatus: 'ZT03',
          //   contractCategory: 'sales',
          //   adminFlag: 2,
          //   selectCompanyCode: '',
          // },
          // changeMethod: 'changeContractMatter',
          // {
          //   prop: 'externalContractNo',
          //   name: this.$t('supplierDeliveryOrder.search.externalContractNo'),
          //   type: 'input',
          //   placeholder: this.$t('supplierDeliveryOrder.search.externalContractNo'),
          // },
          //业务员
          // {
          //   type: 'searchTableSpec',
          //   prop: 'salesmanNo',
          //   name: this.$t('contractAgency.saleMan'),
          //   isMultiple: true,
          //   searchType: 'personnel',
          // },
          {
            prop: 'businessInboundBatchNo',
            name: '入库批次号',
            type: 'input',
            placeholder: '请输入入库批次号',
          },
          {
            prop: 'isRelatedOtherInstruction',
            name: '是否有关联供应商发货指令',
            type: 'select',
            placeholder: '请选择',
            options: this.eList,
          },
          {
            prop: 'relatedInstructionNo',
            name: '关联供应商指令号',
            type: 'input',
            placeholder: '请输入关联供应商指令号',
          },
          {
            prop: 'lockStatus',
            name: '锁定状态',
            type: 'select',
            placeholder: '请选择',
            options: this.lockStatusList,
          },
          {
            prop: 'payStatus',
            name: '付款状态',
            type: 'select',
            placeholder: '请选择',
            options: this.payStatusList,
          },
          // 仓库
          // {
          //   type: 'searchTableSpec',
          //   prop: 'storageNo', // 仓库
          //   name: this.$t('supplierDeliveryOrder.search.storageName'),
          //   searchType: 'warehouse',
          //   isMultiple: true,
          // },
          // {
          //   prop: 'distributionMode',
          //   name: this.$t('supplierDeliveryOrder.search.distributionMode'),
          //   placeholder: this.$t('supplierDeliveryOrder.search.distributionModePlaceholder'),
          //   type: 'ajaxSelect',
          //   apiUrl: BASEAPI.DIC_CREDIT_API,
          //   apiData: { dictType: 'delivery_method' },
          // },
          // {
          //   prop: 'purchaseIntentNo',
          //   name: this.$t('supplierDeliveryOrder.search.purchaseIntentNo'),
          //   type: 'input',
          //   placeholder: this.$t('supplierDeliveryOrder.search.purchaseIntentNoPlaceholder'),
          // },
          // {
          //   prop: 'distributionBatchNo',
          //   name: '物流批次号',
          //   type: 'input',
          //   placeholder: '请输入物流批次号',
          // },
        ];
      },
    },
    /**页面必要代码Start */
    mounted() {
      this.$nextTick(() => {
        this.query.instructionCompanyNo = this.userInfo.companyCode;
        this.getData();
        this.getButtonList();
        this.getDepartment(this.userInfo.companyCode);
        // this.getButtonList();
      });
      this.query = {
        ...this.query,
        ...{
          personIds: [this.userInfo.userCode],
          personNames: this.userInfo.userName,
          instructionDepartmentNo: this.userInfo.departmentCode,
          instructionDepartmentName: this.userInfo.departmentName,
        },
      };
    },
    methods: {
      changeProject({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'projectName') {
          const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
          this.query.projectName = rowData.projectAbbreviation || rowData.projectName || '';
          this.query.projectInitiationNo = rowData.projectInitiationNo || '';
        }
      },
      changePerson({ val, prop }) {
        console.log(val, prop, '==');
        if (prop == 'personNames') {
          const rowData = val && Array.isArray(val) && val.length ? val : [];
          this.query.personNames = rowData.map((item) => item.personName).join(',');
          this.query.personIds = rowData.map((item) => item.id).filter((item) => Boolean(item));
        }
      },
      //重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.$refs.siruiTable.clearCheckboxReserve();
        this.query.personIds = [];
        this.query.personNames = [];
        this.multipleSelection = [];
        this.query.projectInitiationName = '';
        this.query.projectInitiationNo = '';
        this.getData();
      },
      searchBtnClick() {
        this.getData();
      },
      //行项目样式
      rowStyle({ row }) {
        const isDuplicate = row?.isDuplicate || '';
        if (isDuplicate) {
          return {
            backgroundColor: 'rgb(228, 120, 120)',
            color: '#fff',
          };
        }
      },
      //获取菜单按钮
      getButtonList() {
        this.getButtons().then((e) => {
          this.menuButtonList = e || [];
          this.getColumnInfo();
        });
      },
      //获取当前列
      getColumnInfo() {
        this.getColumnList(this.columnListDefault).then(() => {
          this.columnList = this.columnListDefault;
          // this.columnList = res.length === 0 ? this.columnListDefault : res;
        });
      },
      // 选择公司
      searchCompanyName(val) {
        console.log(val);
        this.departmentList = [];
        this.query.instructionDepartmentNo = '';
        this.query.instructionDepartmentName = '';
        this.getDepartment(val.val);
      },
      //获取部门
      async getDepartment(companyCode) {
        // const selectStatus = await this.$axios.post(
        //   BASEAPI.LIST_DEPARTMENT_API + `/${companyCode}`
        // );
        // this.departmentList = selectStatus.data.data;
        // 取一级部门的最后一级部门 收票部门
        if (companyCode) {
          let params = {
            id: this.userInfo.userCode,
            userCode: this.userInfo.userCode,
            personName: this.userInfo.userName,
            personCompanyCode: companyCode,
          };
          const selectStatus = await this.$axios.post(BASEAPI.GET_PERSON_API, params);
          if (selectStatus.data.code == 0) {
            this.departmentList = selectStatus.data.data.personDepartmentInfo.map((item) => {
              return {
                value: item.personDepartmentCode,
                label: item.personDepartmentName,
              };
            });
          }
        } else {
          this.departmentList = [];
        }
      },
      //下拉中文转换
      transferSelectLabel(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      //列表发货指令编号链接
      instructionNoClick(val) {
        let path = {
          path: '/wareHouse/addSupplierDelivery',
          name: 'addSupplierDelivery',
          meta: {
            keepAlive: true,
            title: '创建供应商发货指令',
          },
          query: { instructionNo: val.instructionNo, type: 2, flag: 1 },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //获取数据
      getData() {
        this.load = true;
        const query = this.$refs.siruiSearch.query;
        query.pageSize = this.$refs.siruiTable.page.pageSize;
        query.pageNum = this.$refs.siruiTable.page.pageNum;
        // query.instructionDepartmentNo = this.userInfo.departmentCode;
        // query.instructionDepartmentName = this.userInfo.departmentName;
        // query.instructionCompanyNo=this.userInfo.companyCode;
        if (query.partnerNo && query.partnerNo.length > 0) {
          //供应商
          query.partnerNo = query.partnerNo[0].partnerCode || query.partnerNo;
          //  query.partnerNo = this.handleData(query.partnerNo, "partnerCode");//供应商
        }
        if (query.productNo && query.productNo.length > 0) {
          //商品
          query.productNo = query.productNo[0].productDetailCode || query.productNo;
          //  query.productNo = this.handleData(query.productNo, "productDetailCode");//商品描述
        }
        if (query.salesmanNo && query.salesmanNo.length > 0) {
          //业务员
          query.salesmanNo = query.salesmanNo[0].id || query.salesmanNo;
        }
        // query.instructionCompanyName=this.userInfo.companyName;
        // query.instructionCompanyNo=this.userInfo.companyNo;
        if (query.instructionCreatePersonNo && query.instructionCreatePersonNo.length > 0) {
          //制单人
          query.instructionCreatePersonNo =
            query.instructionCreatePersonNo[0].id || query.instructionCreatePersonNo;
        }
        // query 里已没有该字段
        // if (query.storageNo && query.storageNo.length > 0) {
        //   //仓库
        //   query.storageNo = query.storageNo[0].storageCode || query.storageNo;
        // }
        this.$axios.post(API.GET_DATA_API, query).then((res) => {
          this.load = false;
          if (0 == res.data.code) {
            this.tableData = res.data.data.list;
            this.tableData.forEach((table) => {
              if (table.instructionStatus === '3' || table.instructionStatus === '0') {
                table.businessInboundBatchNo = '';
                table.businessInboundNo = '';
              }
            });
            this.$refs.siruiTable.setPageTotal(res.data.data.total);
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      //处理数据
      handleData(multipleSelection, key) {
        let selectList = multipleSelection ? multipleSelection : [];
        let list = [];
        selectList.forEach((item) => {
          if (key == 'partnerCode') {
            if (item.allPartnerCode && item['allPartnerCode'] != undefined) {
              list.push(item.allPartnerCode);
            } else {
              list.push(item.partnerCode);
            }
          } else if (key == 'productDetailCode') {
            //合并的数据
            if (item.allProductDetailCode && item['allProductDetailCode'] != undefined) {
              list.push(item.allProductDetailCode);
            } else {
              list.push(item.productDetailCode);
            }
          }
        });
        return list.length != 0 ? list.join(',') : null;
      },
      //调用接口排序
      sortChangeEvent({ column, property, order }) {
        console.info(column, property, order);
      },
      //点击按钮触发的方法
      chooseClick(type) {
        console.log(type);
        if (type == 'add') {
          //新增
          //进入引用合同页面，现在是打开创建页面
          this.$refs.creatDialog.defaultVisible = true;
        }
        // ============ sunxueping 添加批量导入 ============
        else if (type == 'import') {
          this.handleImport();
        }
        // ============ sunxueping 添加导出 ============
        else if (type == 'export') {
          this.export();
        }
        // ============liuhongxia 添加复制===============
        else if (type == 'copy') {
          this.copyContract();
        }
        // ============liuhongxia 生成业务入库单=============
        else if (type == 'addInbound') {
          this.addInbound();
        } else if (type === 'batchDelete') {
          this.handleBatchDelete();
        } else if (type === 'createApply') {
          this.handleCreateApply();
        } else if (type === 'viewRecord') {
          this.handleViewRecord();
        } else if (type == 'print') {
          // 打印
          if (this.multipleSelection.length != 1) {
            this.$message.warning('请选择一行操作');
            return;
          }
          if (this.multipleSelection[0].instructionStatus != '1') {
            this.$message.warning('请选择有效的行');
            return;
          }
          this.$refs.printDialogRef.openDialog({
            instructionNo: this.multipleSelection[0].instructionNo,
            downloadOrPrint: 'print',
          });
        }
      },
      handleCreateApply() {
        console.log(this.multipleSelection, 'handleCreateApply');
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择数据',
            type: 'warning',
          });
        }
        // 数据判断 只能选择同一个项目，且供应商发货指令状态为“业务已入库”且付款状态为“未付款”或“部分付款”且应付费用清单的处理状态为“未处理”且锁定状态为“未锁定”的数据
        // instructionStatus==='1'&&
        let hasProjectErrorStatus = false;
        let hasCurrencyErrorStatus = false;
        let hasInstructErrorStatus = false;
        let hasPayErrorStatus = false;
        let hasProcessErrorStatus = false;
        let hasLockErrorStatus = false;
        const projectInitiationNo = this.multipleSelection[0]?.projectInitiationNo || '';
        const contractCurrency = this.multipleSelection[0]?.contractCurrency || '';
        this.multipleSelection.map((item) => {
          if (item.projectInitiationNo !== projectInitiationNo) {
            hasProjectErrorStatus = true;
          }
          if (item.contractCurrency !== contractCurrency) {
            hasCurrencyErrorStatus = true;
          }
          if (item.instructionStatus !== '1') {
            hasInstructErrorStatus = true;
          }
          if (item.payStatus == 2) {
            hasPayErrorStatus = true;
          }
          if (item.processFlag == 1) {
            hasProcessErrorStatus = true;
          }
          if (item.lockStatus == 1) {
            hasLockErrorStatus = true;
          }
        });
        if (hasProjectErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请选择同一个项目的数据',
            type: 'warning',
          });
        }
        if (hasCurrencyErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请选择同一个币种的数据',
            type: 'warning',
          });
        }
        if (hasInstructErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请选择供应商发货指令状态为已业务入库状态',
            type: 'warning',
          });
        }
        if (hasPayErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请选择付款状态为未付款或部分付款状态',
            type: 'warning',
          });
        }
        if (hasProcessErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请选择应付费用清单的处理状态为未处理',
            type: 'warning',
          });
        }
        if (hasLockErrorStatus) {
          return this.$message({
            showClose: true,
            message: '请选择锁定状态为未锁定的数据',
            type: 'warning',
          });
        }
        // this.multipleSelection.every((item) => {
        //   item.projectInitiationNo === projectInitiationNo
        //     ? (hasErrorStatus = false)
        //     : (hasErrorStatus = true);
        //   item.contractCurrency === contractCurrency
        //     ? (hasErrorStatus = false)
        //     : (hasErrorStatus = true);
        // });
        // this.multipleSelection.map((selected) => {
        //   if (selected.instructionStatus !== '1') {
        //     hasErrorStatus = true;
        //   }
        //   if (selected.payStatus == 2) {
        //     hasErrorStatus = true;
        //   }
        //   if (selected.processFlag == 1) {
        //     hasErrorStatus = true;
        //   }
        //   if (selected.lockStatus == 1) {
        //     hasErrorStatus = true;
        //   }
        // });
        // console.log(hasErrorStatus, 'hasErrorStatus');
        // if (hasErrorStatus) {
        //   return this.$message({
        //     showClose: true,
        //     message: '您选择的数据不能创建付款申请单',
        //     type: 'warning',
        //   });
        // }
        this.paymentList = this.multipleSelection || [];
        this.paymentList.map((item) => {
          item.instructionStatusName = this.transferSelectLabel(
            item.instructionStatus,
            this.instructionStatusOptions
          );
          item.payStatusName = this.transferSelectLabel(item.payStatus, this.payStatusList);
          item.applyMoney = item.unPaidMoney;
          // item.projectInitiationNo = item.projectInitiationNo;
          // item.projectName = item.projectName;
        });
        console.log(this.paymentList, 'paymentList');
        this.paymentDialogVisible = true;
      },
      handlePaymentClose() {
        this.paymentList = [];
        this.paymentDialogVisible = false;
      },
      handleRecordClose() {
        this.recordDialogVisible = false;
        this.recordInstructionNo = '';
        this.businessInboundBatchNo = '';
      },
      handleViewRecord() {
        console.log('handleViewRecord');
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择数据',
            type: 'warning',
          });
        }
        if (this.multipleSelection.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能查看一条数据',
            type: 'warning',
          });
        }
        const recordData = this.multipleSelection[0] || {};
        this.recordInstructionNo = recordData.instructionNo;
        this.businessInboundBatchNo = recordData.businessInboundBatchNo;
        this.recordDialogVisible = true;
      },
      handleBatchDelete() {
        console.log(this.multipleSelection, 'handleBatchDelete');
        if (this.multipleSelection.length === 0) {
          return this.$message({
            showClose: true,
            message: '请选择数据',
            type: 'warning',
          });
        }
        const ids = [];
        this.multipleSelection.forEach((item) => {
          ids.push(item.id);
        });
        // const params = {
        //   ids,
        // };
        this.$axios.post(API.BATCH_DELETE, ids).then((res) => {
          this.load = false;
          if (res.data.code === 0) {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'success',
            });
            this.getData();
          } else {
            this.$message({
              showClose: true,
              message: res.data.msg,
              type: 'error',
            });
          }
        });
      },
      // ============ sunxueping 添加批量导入 ============
      handleImport() {
        this.$refs.SiruiUpload.openDialog(true, '01');
      },
      // 复制
      copyContract() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('supplierDeliveryOrder.msg.copyContractTips'),
            type: 'error',
          });
          return;
        }
        let path = {
          path: '/wareHouse/addSupplierDelivery',
          name: 'addSupplierDelivery',
          meta: {
            keepAlive: true,
            title: '创建供应商发货指令',
          },
          //type =2：双击；type=3:复制
          query: { instructionNo: this.multipleSelection[0].instructionNo, type: 3, flag: 2 },
        };
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      //生成业务入库单
      addInbound() {
        if (this.multipleSelection.length != 1) {
          this.$message({
            showClose: true,
            message: this.$t('supplierDeliveryOrder.msg.copyContractTips'),
            type: 'error',
          });
          return;
        }
        // 如果是直拨的供应商发货指令
        if (this.multipleSelection[0].directDeliver == '1') {
          // 供应商发货指令状态是已保存0，已业务入库2
          // if(this.multipleSelection[0].instructionStatus=='0'||this.multipleSelection[0].instructionStatus=='2'){
          // 直接跳转生成业务入库单界面
          let path = {
            path: '/logistics/businessReceiptAdd',
            name: 'businessReceiptAdd',
            meta: {
              keepAlive: false,
              title: '业务入库',
            },
            query: {
              shipNo: this.multipleSelection[0].instructionNo,
              contractNo:
                this.multipleSelection[0].purchaseContractNo ||
                this.multipleSelection[0].purchaseIntentNo,
              sourceType: '1',
            },
          };
          this.$store.dispatch('tagsView/addTabView', path).then(() => {
            this.$nextTick(() => {
              this.$router.push(path);
            });
          });
          /* }else{
        this.$message({
          showClose: true,
          message: this.$t("supplierDeliveryOrder.msg.directDeliverTips"),
          type: "error"
        });
        return;
      } */
        }
        // 非直拨
        else if (this.multipleSelection[0].directDeliver == '0') {
          // 供应商发货指令状态是已保存0，已确认1
          // if(this.multipleSelection[0].instructionStatus=='0'||this.multipleSelection[0].instructionStatus=='1'){
          let params = {
            shipNo: this.multipleSelection[0].instructionNo,
          };
          this.$refs.businessReceiptDialog.openDialog(params);
          /*   }else{
        this.$message({
          showClose: true,
          message: this.$t("supplierDeliveryOrder.msg.notDirectDeliverTips"),
          type: "error"
        });
        return;
      } */
        }
      },
      //导出
      export() {
        // const selectedList = this.$refs.siruiTable.getCheckboxReserveRecords(); // 历史选中数据
        const query = this.$refs.siruiSearch.query;
        if (query.partnerNo && query.partnerNo.length > 0) {
          //供应商
          // query.partnerNo = query.partnerNo[0].partnerCode || query.partnerNo;
          query.partnerNo = this.handleData(query.partnerNo, 'partnerCode'); //供应商
        }
        // query.instructionCompanyNo=this.userInfo.companyCode;//供应商发货指令公司
        if (query.productNo && query.productNo.length > 0) {
          //商品
          // query.productNo = query.productNo[0].productDetailCode || query.productNo;
          query.productNo = this.handleData(query.productNo, 'productDetailCode'); //商品描述
        }
        if (query.salesmanNo && query.salesmanNo.length > 0) {
          //业务员
          query.salesmanNo = query.salesmanNo[0].id || query.salesmanNo;
        }
        if (query.instructionCreatePersonNo && query.instructionCreatePersonNo.length > 0) {
          //制单人
          query.instructionCreatePersonNo =
            query.instructionCreatePersonNo[0].id || query.instructionCreatePersonNo;
        }
        if (query.storageNo && query.storageNo.length > 0) {
          //仓库
          query.storageNo = query.storageNo[0].storageCode || query.storageNo;
        }
        let ids = [];
        const params = filterEmpty(query);
        params.businessGroup = this.userInfo.businessGroup;
        // params.ids = [];
        // if (selectedList.length > 0) {
        //   selectedList.map((item) => {
        //     ids.push(item.id);
        //   });
        // }
        if (this.multipleSelection.length > 0) {
          this.multipleSelection.map((item) => {
            ids.push(item.id);
          });
        }
        if (!ids.length) {
          this.$confirmAction('提示', '未选中导出单据,系统将按查询条件导出,是否继续?')
            .then(async () => {
              // 获取数据
              this.$axios.post(API.EXPORT_SHIPPINGINSTRUCTION, filterEmpty(params)).then((res) => {
                if (res.data.code === 0) {
                  window.location.href = res.data.data;
                } else {
                  this.$alert(res.data.msg);
                }
              });
            })
            .catch(() => {
              return false;
            });
        } else {
          // 去重
          const selectedIds = [...new Set(ids)];
          params.ids = selectedIds;
          params.businessGroup = this.userInfo.businessGroup;
          // 获取数据
          this.$axios.post(API.EXPORT_SHIPPINGINSTRUCTION, filterEmpty(params)).then((res) => {
            if (res.data.code === 0) {
              window.location.href = res.data.data;
            } else {
              this.$alert(res.data.msg);
            }
          });
        }
      },
      // ================================================
      //双击事件
      dblclickEvent(value) {
        let path = {
          path: '/wareHouse/addSupplierDelivery',
          name: 'addSupplierDelivery',
          meta: {
            keepAlive: true,
            title: '创建供应商发货指令',
          },
          query: { instructionNo: value.row.instructionNo, type: 2, flag: 2 },
        };
        if (value.row.instructionStatus == '1' || value.row.instructionStatus == '2') {
          // path.path = '/wareHouse/supplierDeliveryDetail';
          // path.name = 'supplierDeliveryDetail';
          path.query.disable = true;
        }
        this.$store.dispatch('tagsView/addTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path);
          });
        });
      },
      /**页面必要代码End */
    },
  };
</script>
<style lang="scss" scoped>
  .supplierDeliveryOrder {
    .instructionNoClick {
      text-decoration: underline;
      color: blue;
      cursor: pointer;
    }
  }
</style>
